import ResponsiveModal from "@moneris-portal/responsive-modal";
import { PrimaryButton } from "@moneris-portal/button";
import Hook from "./useEligibilityModal";
import errorIcon from "../../../assets/error_icon.svg";
import "./index.scss";

function EligibilityModal() {
  const { isOpen, variant, handleClose, translate } =
    Hook.useEligibilityModal();

  if (!variant) return null;

  return (
    <ResponsiveModal
      show={isOpen}
      onClose={handleClose}
      title=" "
      displayCrossButton={true}
      closeOnBackdropClick={true}
      id="eligibility_modal"
    >
      <div className="eligibility-modal" role="alertdialog" aria-modal="true"
        aria-labelledby="eligibility-modal-title"
        aria-describedby="eligibility-modal-desc"
      >
        <div className="eligibility-modal__icon-section">
          <img
            src={errorIcon}
            alt="Warning"
            className="eligibility-modal__warning-icon"
          />
        </div>
        <h3 className="eligibility-modal__title" id="eligibility-modal-title">
          {translate(`title-${variant}`)}
        </h3>
        <p className="eligibility-modal__description" id="eligibility-modal-desc">
          {translate(`body-${variant}`)}
        </p>
        <div className="eligibility-modal__buttons">
          <PrimaryButton
            title={translate("okay")}
            clickHandler={handleClose}
          />
        </div>
      </div>
    </ResponsiveModal>
  );
}

export default EligibilityModal;
